// Feature: calendly-booking-component
// Translations for BookingComponent (es/en)

const translations = {
  es: {
    // Calendar / date selection
    selectDate: 'Elija una fecha',
    previousMonth: 'Mes anterior',
    nextMonth: 'Mes siguiente',
    noSlotsAvailable: 'No hay huecos disponibles para esta fecha.',
    loadingAvailability: 'Cargando disponibilidad...',

    // Days of week (short)
    days: ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá', 'Do'],
    // Days of week (full, for aria labels)
    daysLong: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
    // Months
    months: [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ],

    // Slot selection
    selectSlot: 'Elija un horario',
    backToCalendar: '← Volver al calendario',
    slotFor: 'Huecos disponibles para',

    // Form
    yourDetails: 'Sus datos',
    name: 'Nombre',
    namePlaceholder: 'Su nombre completo',
    email: 'Email profesional',
    emailPlaceholder: 'nombre@empresa.com',
    phone: 'Teléfono',
    phonePlaceholder: '+34 600 000 000',
    subject: 'Asunto',
    subjectPlaceholder: 'Asunto de la reunión (opcional)',
    comments: 'Comentarios',
    commentsPlaceholder: 'Lo que debamos saber antes de la demostración (opcional)',
    submit: 'Confirmar reserva',
    submitting: 'Confirmando...',
    backToSlots: '← Volver a los horarios',

    // Validation errors
    nameRequired: 'El nombre es obligatorio.',
    emailInvalid: 'Introduzca un correo válido.',
    phoneRequired: 'El teléfono es obligatorio.',
    privacyRequired: 'Debe aceptar la política de privacidad.',

    // Privacy
    privacyLabel: 'Acepto la política de privacidad y el tratamiento de mis datos para gestionar esta solicitud.',

    // Confirmation
    bookingConfirmed: 'Solicitud recibida',
    confirmationMessage: 'Nuestro equipo revisará su solicitud y le enviará una convocatoria con el enlace de la reunión.',
    bookingId: 'Referencia de reserva',
    date: 'Fecha',
    time: 'Hora',
    timezone: 'Zona horaria',
    newBooking: 'Hacer otra reserva',

    // Error state
    errorTitle: 'Ha ocurrido un error',
    errorSlotTaken: 'El hueco elegido ya no está disponible. Elija otro horario.',
    errorRateLimit: 'Ha alcanzado el límite de reservas. Inténtelo más tarde.',
    errorGeneric: 'No se ha podido completar la reserva. Inténtelo de nuevo.',
    retry: 'Reintentar',
    backToStart: 'Volver al inicio',
  },

  en: {
    // Calendar / date selection
    selectDate: 'Select a date',
    previousMonth: 'Previous month',
    nextMonth: 'Next month',
    noSlotsAvailable: 'No slots available for this date.',
    loadingAvailability: 'Loading availability...',

    // Days of week (short)
    days: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
    // Days of week (full, for aria labels)
    daysLong: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    // Months
    months: [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ],

    // Slot selection
    selectSlot: 'Select a time slot',
    backToCalendar: '← Back to calendar',
    slotFor: 'Available slots for',

    // Form
    yourDetails: 'Your details',
    name: 'Name',
    namePlaceholder: 'Your full name',
    email: 'Work email',
    emailPlaceholder: 'you@company.com',
    phone: 'Phone',
    phonePlaceholder: '+34 600 000 000',
    subject: 'Subject',
    subjectPlaceholder: 'Meeting subject (optional)',
    comments: 'Comments',
    commentsPlaceholder: 'Anything we should know before the demo (optional)',
    submit: 'Confirm booking',
    submitting: 'Confirming...',
    backToSlots: '← Back to time slots',

    // Validation errors
    nameRequired: 'Name is required.',
    emailInvalid: 'Please enter a valid email address.',
    phoneRequired: 'Phone number is required.',
    privacyRequired: 'You must accept the privacy policy.',

    // Privacy
    privacyLabel: 'I accept the privacy policy and the processing of my data to manage this request.',

    // Confirmation
    bookingConfirmed: 'Request received!',
    confirmationMessage: 'Our team will review your request and send you a meeting invitation with the link shortly.',
    bookingId: 'Booking reference',
    date: 'Date',
    time: 'Time',
    timezone: 'Timezone',
    newBooking: 'Make another booking',

    // Error state
    errorTitle: 'An error occurred',
    errorSlotTaken: 'The selected slot is no longer available. Please choose another time.',
    errorRateLimit: 'You have reached the booking limit. Please try again later.',
    errorGeneric: 'Could not complete the booking. Please try again.',
    retry: 'Retry',
    backToStart: 'Back to start',
  },
};

/**
 * Get translations for a given locale.
 * Falls back to 'es' if locale is not supported.
 * @param {string} locale - 'es' or 'en'
 * @returns {object} translation strings
 */
export function getTranslations(locale) {
  return translations[locale] || translations['es'];
}

export default translations;
